/* The Orchard: fruit hangs on threads and sways in the breeze your cursor makes (springs integrated and drawn every
   display frame). Tap a fruit and its thread snaps and it drops into the basket (tap it there to hang it back);
   "Shake the tree" drops everything that's left. The button under the basket puts what's in it into the tote. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  var SLOTS = 6;
  WH.register('orchard', function (sec) {
    var tree = sec.querySelector('[data-tree]'), treeImg = sec.querySelector('[data-tree-img]');
    var basket = sec.querySelector('[data-basket]'), basketImg = sec.querySelector('[data-basket-img]');
    var shakeBtn = sec.querySelector('[data-shake]'), rehangBtn = sec.querySelector('[data-rehang]');
    var take = sec.querySelector('[data-take]'), takeBtn = sec.querySelector('[data-take-btn]'), takeN = sec.querySelector('[data-take-n]');
    var takeMore = sec.querySelector('[data-take-more]'), takeErr = sec.querySelector('[data-take-err]');
    var st = Array.prototype.slice.call(sec.querySelectorAll('[data-fruit]')).map(function (el, i) {
      return { el: el, swing: el.querySelector('[data-swing]'), body: el.querySelector('[data-fruit-body]'), thread: el.querySelector('[data-thread]'),
        pick: el.querySelector('[data-pick]'), variant: el.getAttribute('data-variant'), out: el.hasAttribute('data-out'),
        a: 0, v: 0, k: 0.010 + (i % 3) * 0.0022, seed: i * 1.7, down: false, slot: -1 };
    });
    var px = -9999, py = -9999, pvx = 0, lastX = null, visible = false, busy = false, gustQueued = false;
    function gust() {
      gustQueued = false;
      st.forEach(function (s) {
        if (s.down) return;
        var r = s.body.getBoundingClientRect(), d = Math.hypot(px - (r.left + r.width / 2), py - (r.top + r.height / 2));
        s.gust = d < 260 ? pvx * 0.0016 * (1 - d / 260) : 0;
      });
    }
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (lastX !== null) pvx = pvx * 0.6 + (e.clientX - lastX) * 0.4;
      lastX = e.clientX; px = e.clientX; py = e.clientY;
      if (visible && !gustQueued) { gustQueued = true; requestAnimationFrame(gust); }
    }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) wake(); }).observe(sec);
    else { visible = true; setTimeout(function () { wake(); }); }

    /* physics, smooth */
    function step(now) {
      if (visible && !WH.reduce) {
        st.forEach(function (s) {
          if (s.down) return;
          var wind = Math.sin(now * 0.0008 + s.seed) * 0.0005 + Math.sin(now * 0.0021 + s.seed * 2) * 0.00025 + (s.gust || 0);
          s.gust = (s.gust || 0) * 0.9;
          s.v += -s.k * s.a + wind;
          s.v *= 0.982;
          s.a = WH.clamp(s.a + s.v, -0.75, 0.75);
          s.swing.style.transform = 'rotate(' + s.a.toFixed(3) + 'rad)';
        });
        pvx *= 0.9;
      }
      if (visible) requestAnimationFrame(step); else looping = false;
    }
    var looping = false;
    function wake() { if (!looping && !WH.reduce) { looping = true; requestAnimationFrame(step); } }

    /* the basket: two rows of three; picks fill the front row first, the front row sits in front. A spot is [x, where the
       fruit's bottom goes, front row] as shares of the basket picture: the bottoms are below the rim, and the basket's front
       wall is drawn again over the fruit, so it sits inside. A fruit in the basket is TALL of the basket's height. */
    var SPOT = [[0.5, 0.695, 1], [0.28, 0.675, 1], [0.72, 0.675, 1], [0.39, 0.625, 0], [0.61, 0.625, 0], [0.5, 0.61, 0]], TALL = 0.38;
    function home(s) {  /* the fruit's box where it hangs, without the moves that took it to the basket */
      var o = s.swing.getBoundingClientRect();
      return { left: o.left + s.body.offsetLeft, top: o.top + s.body.offsetTop, width: s.body.offsetWidth, height: s.body.offsetHeight };
    }
    function target(s) {  /* the body scales from its top centre, so this puts its bottom centre on the spot */
      var b = basket.getBoundingClientRect(), r = home(s), spot = SPOT[s.slot] || SPOT[0], k = TALL * b.height / r.height;
      return { x: b.left + b.width * spot[0] - (r.left + r.width / 2), y: b.top + b.height * spot[1] - k * r.height - r.top, scale: k, z: spot[2] ? 4 : 3 };
    }
    function freeSlot() {
      for (var k = 0; k < SLOTS; k++) if (!st.some(function (s) { return s.down && s.slot === k; })) return k;
      return 0;
    }
    function inBasket() { return st.filter(function (s) { return s.down; }); }
    function sync() {
      var n = inBasket().length;
      if (take) {
        take.hidden = n === 0;
        takeN.textContent = n;
        if (takeMore) takeMore.hidden = n % 4 !== 3;  /* three in the basket: the fourth would be free */
        if (takeErr && n === 0) takeErr.hidden = true;
      }
      if (rehangBtn) rehangBtn.hidden = n === 0;
      if (shakeBtn) shakeBtn.hidden = n === st.length;
      st.forEach(function (s) {
        s.pick.setAttribute('aria-pressed', s.down ? 'true' : 'false');
        s.pick.setAttribute('aria-label', s.pick.getAttribute(s.down ? 'data-on' : 'data-off'));
      });
    }
    function showTag(s) {
      s.body.classList.add('is-tagged');
      clearTimeout(s.tagT);
      s.tagT = setTimeout(function () { s.body.classList.remove('is-tagged'); }, 1800);
    }

    function drop(s, after) {
      s.down = true;
      s.slot = freeSlot();
      s.a = 0; s.v = 0;
      s.swing.style.transform = 'rotate(0rad)';
      s.el.classList.add('is-down');
      var t = target(s);
      s.el.style.zIndex = t.z;
      if (!WH.anim) { if (window.gsap) gsap.set(s.body, { x: t.x, y: t.y, scale: t.scale }); if (after) after(); return; }
      gsap.to(s.thread, { scaleY: 0, duration: 0.17, ease: WH.sm('power2.out', 0.17) });
      var hop = basket.offsetHeight * 0.1;
      gsap.timeline({ onComplete: after })
        .to(s.body, { x: t.x * 0.5, y: t.y * 0.4 - 20, rotation: WH.rand(-30, 30), duration: 0.25, ease: WH.sm('power1.out', 0.25) })
        .to(s.body, { x: t.x, y: t.y, scale: t.scale, duration: 0.34, ease: WH.sm('power2.in', 0.34) })
        .add(function () { WH.sound.play('thud'); })
        .to(s.body, { y: t.y - hop, rotation: WH.rand(-10, 10), scaleY: t.scale * 1.09, duration: 0.17, ease: WH.sm('power1.out', 0.17) })
        .to(s.body, { y: t.y, scaleY: t.scale, duration: 0.17, ease: WH.sm('power1.in', 0.17) });
    }
    /* when one is taken out, the one furthest back rolls into the gap, so the front row stays full */
    function repack() {
      for (;;) {
        var inb = inBasket(), used = inb.map(function (s) { return s.slot; }), hole = -1;
        for (var k = 0; k < SLOTS && hole < 0; k++) if (used.indexOf(k) < 0) hole = k;
        var last = inb.filter(function (s) { return !s.moving; }).sort(function (a, b) { return b.slot - a.slot; })[0];
        if (hole < 0 || !last || last.slot < hole) return;
        last.slot = hole;
        var t = target(last);
        last.el.style.zIndex = t.z;
        if (WH.anim) gsap.to(last.body, { x: t.x, y: t.y, scale: t.scale, duration: 0.34, ease: WH.sm('power2.inOut', 0.34) });
        else if (window.gsap) gsap.set(last.body, { x: t.x, y: t.y, scale: t.scale });
      }
    }
    /* the basket moves with the page width: fruit in it follows */
    var fitT;
    window.addEventListener('resize', function () {
      clearTimeout(fitT);
      fitT = setTimeout(function () {
        inBasket().forEach(function (s) { if (!s.moving && window.gsap) { var t = target(s); gsap.set(s.body, { x: t.x, y: t.y, scale: t.scale }); } });
      }, 150);
    }, { passive: true });
    function hangBack(s, delay, after) {
      var done = function () { s.down = false; s.slot = -1; s.el.style.zIndex = ''; s.el.classList.remove('is-down'); if (after) after(); };
      if (!WH.anim) { if (window.gsap) { gsap.set(s.body, { clearProps: 'transform' }); gsap.set(s.thread, { scaleY: 1 }); } done(); return; }
      gsap.timeline({ delay: delay || 0, onComplete: done })
        .to(s.body, { x: 0, y: 0, scale: 1, scaleY: 1, rotation: 0, duration: 0.5, ease: WH.sm('back.out(1.6)', 0.5) })
        .to(s.thread, { scaleY: 1, duration: 0.17, ease: WH.sm('power1.out', 0.17) }, '-=0.15');
    }

    /* one at a time */
    st.forEach(function (s) {
      s.pick.addEventListener('click', function () {
        if (busy || s.moving) return;
        s.moving = true;
        if (!s.down) {
          WH.sound.play('pop');
          var r = s.body.getBoundingClientRect();
          WH.puff(r.left + r.width / 2, r.top + 6, 5);
          drop(s, function () { s.moving = false; showTag(s); sync(); });
        } else {
          WH.sound.play('boing');
          hangBack(s, 0, function () { s.moving = false; repack(); sync(); });
        }
        sync();
      });
    });

    /* all at once */
    function shake() {
      if (busy) return;
      busy = true;
      shakeBtn.disabled = true;
      WH.sound.play('rustle');
      st.forEach(function (s) { if (!s.down) s.v += WH.rand(-0.09, 0.09); });
      if (!WH.anim) { dropAll(); return; }
      var r = tree.getBoundingClientRect();
      WH.puff(r.left + r.width * 0.5, r.top + r.height * 0.25, 12, true);
      /* the tree and the fruit still on it rock around the foot of the trunk; fruit already in the basket stays put */
      var parts = [treeImg].concat(st.filter(function (s) { return !s.down; }).map(function (s) { return s.el; }));
      var fx = r.left + r.width / 2, fy = r.bottom;
      gsap.set(parts, { transformOrigin: function (i, el) { var e = el.getBoundingClientRect(); return (fx - e.left) + 'px ' + (fy - e.top) + 'px'; } });
      gsap.timeline({ onComplete: function () { gsap.set(parts, { clearProps: 'transform,transformOrigin' }); dropAll(); } })
        .to(parts, { rotation: -4, duration: 0.09, ease: 'none' })
        .to(parts, { rotation: 4, duration: 0.17, ease: 'none', repeat: 3, yoyo: true })
        .to(parts, { rotation: 0, duration: 0.17, ease: WH.sm('power1.out', 0.17) });
    }
    function dropAll() {
      var live = st.filter(function (s) { return !s.down; });
      live.forEach(function (s, i) { setTimeout(function () { drop(s); sync(); }, i * 230); });
      setTimeout(function () { busy = false; shakeBtn.disabled = false; sync(); }, live.length * 230 + 900);
    }
    function rehangAll() {
      if (busy) return;
      WH.sound.play('boing');
      inBasket().forEach(function (s, i) { hangBack(s, i * 0.08, sync); });
    }
    if (shakeBtn) shakeBtn.addEventListener('click', shake);
    if (rehangBtn) rehangBtn.addEventListener('click', rehangAll);

    /* the basket goes into the tote: every friend in it, one of each; buy 3, get 1 free works on them as usual */
    if (takeBtn) takeBtn.addEventListener('click', function () {
      var picked = inBasket().filter(function (s) { return !s.out && s.variant; });
      if (!picked.length || busy) return;
      takeBtn.disabled = true;
      if (takeErr) takeErr.hidden = true;
      WH.cart.add({ items: picked.map(function (s) { return { id: +s.variant, quantity: 1 }; }) }, basketImg)
        .then(function () { setTimeout(function () { inBasket().forEach(function (s, i) { hangBack(s, i * 0.08, sync); }); }, 700); })
        .catch(function (x) { if (takeErr) { takeErr.textContent = x.message; takeErr.hidden = false; } })
        .then(function () { takeBtn.disabled = false; });
    });
    sync();
  });
})();
